module.exports = __webpack_public_path__ + "img/ex-tasks_lg.b201fcaf.png";